import React from 'react';
import TopStepAccountPage from './TopStepAccountPage';

const TopStep150KChallengePage: React.FC = () => (
  <TopStepAccountPage
    accountLabel="TopStep 150K Challenge"
    accountMatcher={(accts) => accts.find(a => a.accountName.toUpperCase().includes('150K'))}
    challengeParams={{ target: 9000, hardMax: 4500, internalStop: 3825, dailyCap: 1800, accountSize: 150000 }}
    chipLabel="150K CHALLENGE"
    chipColor="#E040FB"
  />
);

export default TopStep150KChallengePage;
